import { render, staticRenderFns } from "./ContainerType.vue?vue&type=template&id=3bed8d2c&lang=pug&"
import script from "./ContainerType.vue?vue&type=script&lang=js&"
export * from "./ContainerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports